module.exports = __webpack_public_path__ + "static/media/mail.aa2e3b70.svg";